/**
 * Payment method constants and utilities
 * Single source of truth for all payment methods across the app
 */

/**
 * Valid payment method values
 */
export const PAYMENT_METHODS = {
  CASH_APP: 'cash_app',
  VENMO: 'venmo',
  ZELLE: 'zelle',
  BANK_DEPOSIT: 'cash_bank_deposit',
  CHECK: 'check',
  CARD: 'card',
  TRANSFER: 'transfer',
  DISCOUNT: 'discount',
  CASH: 'cash',
};

/**
 * Payment method display labels
 */
export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.CASH_APP]: 'Cash App',
  [PAYMENT_METHODS.VENMO]: 'Venmo',
  [PAYMENT_METHODS.ZELLE]: 'Zelle',
  [PAYMENT_METHODS.BANK_DEPOSIT]: 'Bank Deposit',
  [PAYMENT_METHODS.CHECK]: 'Paper Check',
  [PAYMENT_METHODS.CARD]: 'Card',
  [PAYMENT_METHODS.TRANSFER]: 'Transfer',
  [PAYMENT_METHODS.DISCOUNT]: 'Discount',
  [PAYMENT_METHODS.CASH]: 'Cash',
};

/**
 * Payment method options for dropdown selects
 * Compatible with existing paymentMethodOptions.js
 */
export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.CASH_APP, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.CASH_APP] },
  { value: PAYMENT_METHODS.VENMO, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.VENMO] },
  { value: PAYMENT_METHODS.ZELLE, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.ZELLE] },
  { value: PAYMENT_METHODS.BANK_DEPOSIT, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.BANK_DEPOSIT] },
  { value: PAYMENT_METHODS.CHECK, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.CHECK] },
  { value: PAYMENT_METHODS.CARD, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.CARD] },
  { value: PAYMENT_METHODS.TRANSFER, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.TRANSFER] },
  { value: PAYMENT_METHODS.DISCOUNT, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.DISCOUNT] },
  { value: PAYMENT_METHODS.CASH, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.CASH] },
];

/**
 * Get display label for a payment method value
 * @param {string} value - Payment method value
 * @returns {string} Display label
 */
export const getPaymentMethodLabel = (value) => {
  return PAYMENT_METHOD_LABELS[value] || value;
};

/**
 * Render payment method options for a <select> element
 * Usage: <select>{renderPaymentMethodOptions()}</select>
 */
export const renderPaymentMethodOptions = () => {
  return PAYMENT_METHOD_OPTIONS.map(({ value, label }) => (
    <option key={value} value={value}>
      {label}
    </option>
  ));
};
